import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PaintBrush } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { THEMES, applyTheme } from "@/lib/theme";

export default function ThemeCard({ canEdit }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/theme").then((r) => setData(r.data)).catch(() => {}); }, []);

  const choose = async (theme) => {
    if (!canEdit || busy || theme === data?.theme) return;
    setBusy(true);
    try {
      await api.put("/settings/theme", { theme });
      setData((s) => ({ ...s, theme }));
      applyTheme(theme);
      toast.success(`Tema: ${THEMES[theme].label}`);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  if (!data) return null;
  return (
    <div className="panel fade-up p-6" data-testid="theme-card">
      <h3 className="flex items-center gap-2 font-display text-lg font-bold"><PaintBrush size={18} /> Renk Teması</h3>
      <p className="mt-1 text-xs text-muted-foreground">Firma genelinde geçerlidir; tüm kullanıcılar seçilen temayı görür.{!canEdit && " Değiştirmek için yönetici yetkisi gerekir."}</p>
      <div className="mt-4 grid gap-2 sm:grid-cols-4">
        {data.options.map((o) => {
          const t = THEMES[o.id];
          return (
            <button key={o.id} type="button" disabled={!canEdit || busy} onClick={() => choose(o.id)} data-testid={`theme-option-${o.id}`}
              className={`rounded-md border p-3 text-left text-sm transition-colors ${data.theme === o.id ? "border-teal-600 bg-teal-50 font-semibold text-teal-900" : "border-border hover:bg-muted disabled:opacity-60"}`}>
              <div className="mb-2 flex h-8 overflow-hidden rounded border border-black/10">
                <span className="w-1/3" style={{ background: t.sidebar }} />
                <span className="flex-1" style={{ background: t.bg }} />
              </div>
              {o.label}{data.theme === o.id && <span className="ml-1 text-xs text-teal-700">· Seçili</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
